import * as gestureHandler from 'global.gestureHandler';
import * as headerSearch from 'header.search';
import * as headerStickyDesktop from 'header.stickyDesktop';
import * as headerTooltips from 'header.tooltips';

import DeliveryZip from 'header.deliveryzip';
import FooterEmail from 'footer.email';
import footerOrderTracking from 'footer.orderTracking';
import footerPclink from 'footer.pcLink';
import headerAnalytics from 'header.analytics';
import headerCart from 'header.cart';
import headerDIYFlyout from 'header.diyflyout';
import headerDropDowns from 'header.dropdownmodule';
import headerHomeDecorFurnitureFlyout from 'header.homedecorfurnitureflyout';
import headerHsFlyout from 'header.hsflyout';
import headerLogo from 'header.logo';
import headerMainFlyout from 'header.mainflyout';
import headerMyaccount from 'header.myaccount';
import headerShoppingLinks from 'header.shoppinglinks';
import headerSimpleFlyout from 'header.simpleflyout';
import headerSpecialsFlyout from 'header.specialsflyout';
import headerStoreFinder from 'header.storefinder';
import headerStorefinderCore from 'header.storefinder.core';
import headerTaskLinks from 'header.tasklinks';

// Initialize all modules
const initializeModules = () => {
  const useJsonP = !!location.port || false;

  headerAnalytics.init();
  headerCart.init();
  headerMainFlyout.init();
  headerSimpleFlyout.init();
  headerHomeDecorFurnitureFlyout.init();
  headerSpecialsFlyout.init();
  headerDIYFlyout.init();
  headerHsFlyout.init();
  headerDropDowns.init();
  headerLogo.init();
  headerMyaccount.init(useJsonP);
  headerSearch.init();
  headerTooltips.init();
  headerStorefinderCore.init();
  headerStoreFinder.init();
  headerShoppingLinks.init();
  headerTaskLinks.init();
  FooterEmail.init();
  footerPclink.init();
  footerOrderTracking.init();
  gestureHandler.init();
  headerStickyDesktop.init();
  DeliveryZip.init();

  // Triggers HFApp is loaded and ready
  document.dispatchEvent(new Event('hfapp-ready'));
};

window.addEventListener('DOMContentLoaded', (event) => initializeModules());
